import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'
import { WEB_MARKETING_HERO_IMAGE } from 'src/modules/reducers/cohorts/constants'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'
import { useHeroImageByWidth } from 'src/modules/hooks/useHeroImageByWidth'

export default (props) => {
  const heroImage = useCohortFlag(WEB_MARKETING_HERO_IMAGE)
  const heroImageByWidth = useHeroImageByWidth(heroImage)

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      title={commonTitleText.streamLiveTVSports}
      subtitle={commonSubtitleText.onAnyDevice}
      showRSN={true}
      poster={heroImageByWidth}
      isHeroDefault={!heroImageByWidth}
    />
  )
}
